import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { GLOBAL_IR_SATELLITE_COMPOSITE_LEGEND } from './global-ir-satellite-composite.legend';
import { GLOBAL_IR_SATELLITE_COMPOSITE_PRODUCT_DATA } from './global-ir-satellite-composite.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class GlobalIRSatelliteCompositePluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(
    GLOBAL_IR_SATELLITE_COMPOSITE_PRODUCT_DATA,
    {
      legend: GLOBAL_IR_SATELLITE_COMPOSITE_LEGEND,
      twcLayerTypes: ['web-tile']
    }
  );
}
